module.exports = ".navbar {\n  border-radius: 0;\n  padding: 0 15px 0 0; }\n"